export default __webpack_public_path__ + "static/media/the-air-filter-company.9b55f644.svg";